export default {
  'watchlist.page-title': 'Watchlist',
  'watchlist.sponsored.title': 'Sponsored Watchlist',
  'watchlist.sponsored.text':
    'Get your coin among the basics: BTC, ETH in our watchlist for every new install.',
  'watchlist.preset.title': '93.3%',
  'watchlist.preset.text':
    'Of users keep the pre-set coins in their price watchlist.',
  'watchlist.convert.title': '0.3%',
  'watchlist.convert.text':
    'Of users convert from watchlist to portfolio, meaning they invested in the projects.',

  'watchlist.details.title.details': 'Campaign details',
  'watchlist.details.title.reach': 'Campaign reach',
  'watchlist.details.coin': 'Coin',
  'watchlist.details.quota': 'Quota',
  'watchlist.details.installs.left': 'Installs Left',
  'watchlist.details.installs.total': 'Total Installs',
  'watchlist.details.installs.day': 'Installs Last Day',
  'watchlist.details.installs.week': 'Installs Last Week',
  'watchlist.details.installs.month': 'Installs Last Month',
  'watchlist.details.created': 'Created',
  'watchlist.details.active.watchlists': 'Active In # Of Watchlists',
  'watchlist.details.active.portfolios': 'Active in # Of Portfolios',
  'watchlist.details.median': 'Median Portfolio Worth',
};
